import { observer } from 'mobx-react';
import { Component } from 'react';

import { CssAnimation } from '../../../shared/animations';
import { AnimatedComponent } from '../AnimatedComponent';
import type { AnimatedComponentProps } from '../AnimatedComponent';
import css from './AnimatedProductModelsPanel.css';

export class ProductModelsPanelAnimations {
  hide: CssAnimation;
  show: CssAnimation;

  constructor() {
    this.hide = new CssAnimation();
    this.show = new CssAnimation();
  }
}

@observer
export class AnimatedProductModelsPanel extends Component<AnimatedComponentProps, {}> {
  constructor(props: AnimatedComponentProps) {
    super(props);
  }

  render() {
    return <AnimatedComponent {...this.props} css={css} />;
  }
}
